import MUIDataTable from "mui-datatables";


const options = {
    search: true,
    download: true,
    print: false,
    viewColumns: true,
    filter: true,
    filterType: "dropdown",
    responsive: "vertical",
    tableBodyHeight: "600px",
    selectableRows: false,
    sortDescFirst: false,
    onTableChange: (action, state) => {
        console.log(action);
        console.dir(state);
    },
    sortOrder: null,
    onDownload: (buildHead, buildBody, columns, data) => {
        //1. adding the BOM (Unicode Byte Order Mark) to the CSV content, for Excel encoding
        ////solves an issue with malformed data due to Unicode, could cause issues with other programs    .
        //2. removing the U+200E character from document data
     const csvContent = "\uFEFF" + buildHead(columns) + buildBody(data);
     return csvContent.replace(/\u200E/g, '')}
};


export const ReportTable = (props: { data, columns }) => {

    options.sortOrder = {
        name: 'Date',
        direction: 'asc',
    }

    return (<MUIDataTable
        title={"Report"}
        data={props.data}
        columns={props.columns}
        options={options}
    />)
};



